




































import { Component, Prop, Vue } from 'vue-property-decorator';
import AmountSelector from '@/common/AmountSelector.vue';
import { LabelSelectionApi, ProductBasePrice, ProductNetFillQuantity } from '@eurogast/hub-client-typescript';
import { NumberFormatter } from '@/services/NumberFormatter';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';
import Store from '@/store';
import { Mutations } from '@/store/types';
import { LinkUtil } from '@/services/LinkUtil';
import MatomoEvents from '@/matomo/events/MatomoEvents';


@Component({
  components: {
    AmountSelector
  }
})
export default class LabelPrintItem extends Vue {
  @Prop({ required: true })
  public localSku: string;
  @Prop()
  public localBasePrice: ProductBasePrice;
  @Prop()
  public localImagePath: string;
  @Prop()
  public localProductName: string;
  @Prop()
  public localNetFillQuantity: ProductNetFillQuantity;

  public removed: boolean = false;

  public currentAmount: number = 1;

  private labelSelectionApi = ApiService.wrap(LabelSelectionApi);

  get findImageUrl(): string {
    return ConfigService.getAssetBaseUrl() + '/' + this.localImagePath;
  }

  public findDetailUrl(productName: string, productSku: string): string {
    return LinkUtil.getProductDetailUrl(productName, productSku);
  }

  public removeFromList() {
    MatomoEvents.forLabelPage.removeAll.publish();
    this.removed = true;
    Store.commit(Mutations.LabelSelection.removeSku, this.localSku);
    this.labelSelectionApi
      .deleteItemFromLabelPrint(ConfigService.getTenant(), this.localSku, ConfigService.currentCustomerId);
  }

  public restoreIntoList() {
    MatomoEvents.forLabelPage.addLabel.publish();
    this.removed = false;
    Store.commit(Mutations.LabelSelection.restoreLabelPrint, { sku: this.localSku, amount: this.currentAmount });
    this.labelSelectionApi
      .addItemToLabelPrint(ConfigService.getTenant(), this.localSku, ConfigService.currentCustomerId);
  }

  get subtitle() {
    let result = '';
    let empty = true;
    if (this.localNetFillQuantity && this.localNetFillQuantity.unit) {
      result += NumberFormatter.formatFillQuantity(this.localNetFillQuantity.quantity);
      result += this.localNetFillQuantity.unit.toString();
      empty = false;
    }
    if (this.localSku) {
      if (!empty) {
        result += ' - ';
      }
      result += this.$t('labelPrint.item.productWithSku', { sku: this.localSku }).toString();
    }

    return result;
  }

  public onAmountChange(amount) {
    this.currentAmount = amount;
    Store.commit(Mutations.LabelSelection.setAmount, { sku: this.localSku, amount });
    MatomoEvents.forLabelPage.changeItemAmount.publish();
  }

}
